define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Marionette = require('marionette');
    var modal = require('behaviors/modal');
    var itemTpl = require('text!tmpls/parts/projects/item.tpl').default;
    var Template = require('text!tmpls/parts/projects/main.tpl').default;

    var ItemView = Marionette.ItemView.extend({
        tagName: 'tr',
        template: itemTpl
    });

    var Config = require('config/application');


    return Marionette.CompositeView.extend({
        template: Template,
        childView: ItemView,
        childViewContainer: 'tbody',

        parentBehaviors: {
            'modal': {
                behaviorClass: modal
            }
        },

        newBehaviors: {},

        behaviors: function () {
            return _.extend({}, this.parentBehaviors, this.newBehaviors);
        },

        ui: {
            'nameProjectLink'   : '.js-change-project-name-link',
            'showCodeBtn'       : '.js-show-code',
            'scroll'            : '.js-scroll'
        },

        events: {
            'click tr': 'onClickProject',
            'click .js-modal': 'callModal',
            'click @ui.showCodeBtn' : 'showCode'
        },

        initialize: function () {
            // this.collection = app.Collections.Projects;
            this.collection = this.getFilteredProjects();
            this.model = new Backbone.Model({
                enabledAllSites: app.States.enabledAllSites,
                showAddBtn: true //app.Models.Account.get('sites') < app.Models.Account.get('sites_total')
            });
            app.States.allSites = false;

            app.States.isFirefoxOnMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0 && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

            this.listenTo(app.Collections.Projects, 'change add', this.render);
            this.listenTo(app.Vents, 'projects:select:update', this.updateState);

        },

        getFilteredProjects: function() {
            var projects = new Backbone.Collection();
            var currentUserId = app.Models.User.get('id');
            var currentUserType = app.Models.User.get('profile_type');
            app.Collections.Projects.each(function(projectModel) {
                var users = projectModel.get('users');
                _.each(users, function(user) {
                    if(user.id == currentUserId && user.type == currentUserType) {
                        projects.push(projectModel);
                    }

                });

            });

            return projects;
        },

        updateState: function () {
            this.model = new Backbone.Model({
                'enabledAllSites': app.States.enabledAllSites
            });
            if (app.States.enabledAllSites == false) {
                app.States.allSites = false;
                var id = app.curProject.id;
                app.Models.curProject = app.Collections.Projects.get(id);
                app.curProject = app.Collections.Projects.get(id).toJSON();
                app.Views.Header.render();

            }

            this.render();
        },

        onRender: function () {
            this.$el.lptSetter();
            if (app.States.isFirefoxOnMac) {
                this.ui.scroll.prop('style', 'overflow-y: auto !important;');
            }
        },

        onDestroy: function () {
            app.Vents.off('projects:select:update', this.updateState, this);
            app.Collections.Projects.off('change add', this.render, this);
        },

        showCode: function(event) {
            event.stopPropagation();
            var data = $(event.currentTarget).data();
            this.changeProject(data.id).then(function() {
                Backbone.history.navigate('#code/standart', true);
            })
        },

        onClickProject: function(event, projectId) {
            var self = this;
            var id = projectId || $(event.currentTarget).find('.js-change-project-name-link').data('id');
            this.changeProject(id);
        },

        changeProject: function (id) {
            app.Vents.trigger('app:beforeChangeProject');
            return Backbone.ajax({
                type: 'POST',
                url: Config.host + '/rest/system/change_project/' + id,
                success: function (response) {
                    if (response.status == 1) {
                        if ('caches' in window) {
                            caches.keys()
                                .then(function (cacheNames) {
                                    cacheNames.map(function (cacheName) {
                                        if (cacheName == 'lptracker-data-v2') {
                                            caches
                                                .delete(cacheName)
                                                .catch(function(error) {
                                                    console.warn('Caches delete failed with ' + error);
                                                });
                                        }
                                    })
                                })
                                .catch(function(error) {
                                    console.warn('Caches keys failed with ' + error);
                                });
                        }
                        app.Vents.trigger('app:selectProject', id);
                    }
                },
                error: function (xhr) {
                    if (typeof xhr.responseText != 'undefined') {
                        var response = $.parseJSON(xhr.responseText);
                        if (response.status == 0) {
                            app.message.error(response.message || I18n.basic.oops);
                        }
                    }
                }
            });
        },

        //selectProject: function (id, notReload) {
        //    app.currentProjectId = id;
        //    try {
        //        sessionStorage.setItem('projectId', id);
        //    } catch (e) {}
        //    app.Models.LeftMenuCount.set(
        //        {
        //            leads_new: 0,
        //            deals_new: 0
        //        },
        //        {silent: true}
        //    );
        //    Backbone.ajax({
        //        type: 'GET',
        //        url: Config.host + '/rest/leads/new_count',
        //        success: function (response) {
        //            if (response.status == 1) {
        //                app.Models.LeftMenuCount.set('leads_new', response.result.data.count);
        //            }
        //        }
        //    }).then((function() {
        //        if (app.States.allSites == true) {
        //            app.States.allSites = false;
        //            app.Vents.trigger('projects:change:all');
        //        }
        //
        //        app.message.success('Проект изменен');
        //
        //        app.Models.curProject = app.Collections.Projects.get(id);
        //        app.curProject = app.Collections.Projects.get(id).toJSON();
        //        app.Views.Header.render();
        //        app.Vents.trigger('app:changeProject');
        //        app.trigger('menu:refresh');
        //
        //        if (!notReload && app.curPage && app.curPage.pageName == 'LeadsCard') {
        //            window.location.href = Config.host + '/#leads';
        //        } else if (!notReload && app.curPage && app.curPage.pageName == 'ContactsCard') {
        //            window.location.href = Config.host + '/#contacts';
        //        } else {
        //            app.reloadContent(notReload);
        //        }
        //    }).bind(this))
        //},

        callModal: function (e) {
            e.stopPropagation();
        }
    });
});